    
  function Getattributevalue(att,name) {
    if ( typeof(att) !== "undefined" && att !== null ) {
       for (let key in att) {
            if (att[key][0] === name){
                return att[key][1][0];
            }
        }
    }

    return "";
  }

  var __fast_options = __fast_options || {};
  __fast_options.with_product_attributes = true;
  __fast_options.default_value_for_hide_filters_button = true;
  __fast_options.parseProductTitle = function(title, productData, selectedVariant) {
      var pType = Getattributevalue(productData.attributes,"Type");
      if (pType) {
        return `${title} ${pType}`;
      }
      return title; 
  } 

  /* get all products to loop on */
  function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
  }
  function hooks() {    
        window.SerpOptions.registerHook("serp-top-page", ({element}) => {          
            if (element) {
              const buttonWrapper = element.querySelector('.button-wrapper');
  
              if (buttonWrapper) {
                const button = buttonWrapper.querySelector('.hide-filters-button');
              
                if (buttonWrapper.classList.contains('fs-filters-btn-visible')) {
                  button.textContent = 'FILTER & SORT -';
                } else if (buttonWrapper.classList.contains('fs-filters-btn-hidden')) {
                  button.textContent = 'FILTER & SORT +';
                }
              }
            }
        });
  
        window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {
          for (const productElement of getProductElements(element)) {
            
            // Skip if already enhanced          
            if (productElement.classList.contains('fs-enhanced')) continue;
        
            // Mark as enhanced
            productElement.classList.add('fs-enhanced');        
            
            const productID = productElement.dataset.productId;
            const data = products[productID];
            const tags = data.tags;                       
      
            // var titleWrapper = productElement.querySelector('.fs-product-title');
            // var pType = Getattributevalue(data.attributes,"Type");
            // if (titleWrapper && pType) {
            //   titleWrapper.textContent = `${titleWrapper.textContent} ${pType}`;
            // }
          }
        });
  
  
        window.SerpOptions.registerHook("serp-filters", ({ facets, element }) => {            
          const parent=element.closest(".fs-app-content-center-block");
          if(window.innerWidth<520 && parent && !parent.classList.contains("cst-obs"))
          {
            parent.classList.add("cst-obs");
            document.body.classList.add('fs-filter-open');
            const observer = new MutationObserver(() => {
            const isFilterOpen = Array.from(parent.children).some(
                el => el.classList.contains('filters-modal-wrapper')
              );
              console.log("observerobserverobserver")
              document.body.classList.toggle('fs-filter-open', isFilterOpen);
            });
            
            observer.observe(parent, {
              childList: true, // Only observe direct children
              subtree: false   // Don't watch deeper/nested DOM
            });
          }
             
        });
  }
  
  if (window.SerpOptions) {
      hooks();
  } else {
      window.addEventListener('fast-serp-ready', function () {
          hooks();
      });
  }
  // Upsell
  var __fast_options = __fast_options || {};
  __fast_options.disable_upsell_shadow_root = true;
    
  function horizontalScrollHandler(parent) {
    let mouseDown = false;
    let startX, scrollLeft;
    let dragged = false; // Track if dragging happened
    const slider = parent.querySelector('.carousel-container');
    
    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      dragged = false; // Reset dragged state
      slider.classList.add('dragging'); // Optional: add a class during dragging
    }
    
    const stopDragging = (e) => {
      if (!mouseDown) return;
      mouseDown = false;
      slider.classList.remove('dragging'); // Optional: remove class after dragging
      if (!dragged) {
        // Consider it a click if not dragged
        e.target.click(); // Simulate a click if needed
      }
    }
    
    const move = (e) => {
      if (!mouseDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      if (Math.abs(scroll) > 5) { // Threshold to differentiate drag from click
        dragged = true; // Mark as dragged if movement exceeds threshold
      }
      slider.scrollLeft = scrollLeft - scroll;
  }
  
  // Add the event listeners
  slider.addEventListener('mousemove', move, false);
  slider.addEventListener('mousedown', startDragging, false);
  slider.addEventListener('mouseup', stopDragging, false);
  slider.addEventListener('mouseleave', stopDragging, false);
  
  // Prevent text selection during dragging
  slider.addEventListener('dragstart', (e) => e.preventDefault());
  // Prevent the click event if dragging occurred
  slider.addEventListener('click', (e) => {
    if (dragged) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dragged = false; // Reset dragged state after handling
    }
  }, true); // Use capture phase to intercept before other click handlers
  }
  function upsellHooks() {
      window.FastRecommendationWidget.registerHook('upsell-cross-sell-products', ({products, element}) => {
        horizontalScrollHandler(element)
        const productElements = [...element.querySelectorAll(".fs-upsell-cross-sell-product")];
        for (const productElement of productElements){
          const productID = productElement.dataset.id;
          const data = products[productID];                            
        }
      });
  }
  // execution here
  if (window.FastRecommendationWidget) {
      upsellHooks();
  } else {
      window.addEventListener('fast-upsell-cross-sell-ready', function () {
          upsellHooks();
      });
  }  
